import React from 'react';
import { Target, Eye, Award, Users } from 'lucide-react';
import { COMPANY_INFO, ABOUT_CONTENT, WHY_CHOOSE_US } from '../data/mockData';

const About = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header-section">
        <div className="section-container">
          <h1 className="page-title">About Us</h1>
          <p className="page-subtitle">
            Leading the way in global commodities trading with integrity and excellence
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="content-section">
        <div className="section-container">
          <div className="content-card">
            <h2 className="content-title">Who We Are</h2>
            <p className="content-text">{ABOUT_CONTENT.description}</p>
            <p className="content-text">{ABOUT_CONTENT.foundation}</p>
            <p className="content-text-emphasis">
              At M 360 Commodities, we don't just supply materials—we build partnerships. 
              Whether you are in manufacturing, energy, construction, or industrial sectors, 
              we ensure seamless access to the raw materials you need to succeed.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision-section">
        <div className="section-container">
          <div className="mission-vision-grid">
            <div className="mission-vision-card">
              <div className="mission-vision-icon-wrapper">
                <Target className="mission-vision-icon" size={40} />
              </div>
              <h3 className="mission-vision-title">Our Mission</h3>
              <p className="mission-vision-text">{COMPANY_INFO.mission}</p>
            </div>
            <div className="mission-vision-card">
              <div className="mission-vision-icon-wrapper">
                <Eye className="mission-vision-icon" size={40} />
              </div>
              <h3 className="mission-vision-title">Our Vision</h3>
              <p className="mission-vision-text">{COMPANY_INFO.vision}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Why Choose M 360 Commodities</h2>
          </div>
          <div className="why-grid">
            {WHY_CHOOSE_US.map((item, index) => (
              <div key={index} className="why-card">
                <div className="why-card-header">
                  <div className="why-card-icon">✓</div>
                  <h3 className="why-card-title">{item.title}</h3>
                </div>
                <p className="why-card-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="values-section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Our Core Values</h2>
            <p className="section-subtitle">The foundation of everything we do</p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <Award className="value-icon" size={36} />
              <h3 className="value-title">Integrity</h3>
              <p className="value-description">
                Conducting business with honesty, transparency, and ethical practices
              </p>
            </div>
            <div className="value-card">
              <Users className="value-icon" size={36} />
              <h3 className="value-title">Trust</h3>
              <p className="value-description">
                Building long-term relationships through reliability and commitment
              </p>
            </div>
            <div className="value-card">
              <Award className="value-icon" size={36} />
              <h3 className="value-title">Excellence</h3>
              <p className="value-description">
                Delivering superior quality and exceptional service in every transaction
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
